import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllPartners, doCreatePartner, doUpdatePartner } from "./thunk";

const partnersAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const partnerSlice = createSlice({
  name: "partner",
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllPartners.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllPartners.fulfilled, (state, action) => {
      const { partners, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      partnersAdapter.setAll(state, partners);
    });
    builder.addCase(doGetAllPartners.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreatePartner.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreatePartner.fulfilled, (state, action) => {
      state.isFetching = false;
      partnersAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreatePartner.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdatePartner.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdatePartner.fulfilled, (state, action) => {
      state.isFetching = false;
      partnersAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdatePartner.rejected, state => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllPartners,
  selectById: selectPartnerById,
  selectIds: selectPartnerIds,
} = partnersAdapter.getSelectors(state => state.partner);

const { reducer: partnerReducer } = partnerSlice;
export default partnerReducer;
